<template>
  <v-form ref="form" v-model="validacion" lazy-validation>
    <v-layout v-if="tipeView != 'aprobacion'">
      <v-flex xs12 md8>
        <v-toolbar-title class="indigo--text" style="font-size: 18px"
          >Ingresar Archivo a enviar</v-toolbar-title
        >
        <adjunto :tipeView="tipeView" :tipeArchive="tipeArchive"></adjunto>
        <br />
        <v-textarea
          v-model="observaciones"
          solo
          name="input-7-4"
          label="Ingrese alguna observación adicional si corresponde"
        ></v-textarea>
        <v-select
          v-if="usertype == 'AGENCIA'"
          v-model="estadoGestionValue"
          :items="estadoGestionSelect"
          item-text="nombre"
          item-value="code"
          label="Seleccione el estado de esta gestión"
        ></v-select>
      </v-flex>
    </v-layout>
    <v-card-actions class="pb-3">
      <v-btn
        v-if="tipeView == 'consulta' ? false : true"
        color="primary"
        dark
        :loading="loading"
        class="mb-2"
        @click="save()"
      >
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";
import { error } from "util";
import Adjunto from "@/components/AdjuntoData.vue";
export default {
  name: "productos-data",
  components: {
    Adjunto,
  },
  mixins: [misMixins, validationMixin],
  props: {
    tipeView: "",
    id: "",
    idReporte: "",
  },
  data() {
    return {
      validacion: "",
      loading: false,
      allowSpaces: false,
      idContrato: "",
      usertype: "",
      username: "",
      observaciones: "",
      filenameValue: "",
      documento: "",
      estadoGestionSelect: [],
      estadoGestionValue: "",
      tipeArchive: "",
    };
  },

  validations: {
    estadoValue: { required },
  },

  created() {
    this.tipeArchive = ".pdf,.doc,.docx,.xlsx,.xls,.ppt,.pptx,.rar,.zip";
    this.usertype = this.$store.getters.userLogged.tipo;
    if (this.tipeView === undefined) {
      this.tipeView = this.$route.params.tipeView;
    }
    if (this.tipeView == "crear") {
      this.loadEstados();
    }
  },
  mounted() {
    this.idContrato = this.$store.getters.contratoStored;
    this.idUsuario = this.$store.getters.userLogged.id;
    this.proceso = this.$store.getters.subProTabSelectedStored;
  },
  computed: {
    estadoGestionErrors() {
      const errors = [];
      if (!this.$v.estadoGestionValue.$dirty && usertype == "AGENCIA")
        return errors;
      !this.$v.estadoGestionValue.required &&
        errors.push("Debe seleccionar un estado a la gestión realizada");
      return errors;
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
    },
    back(id, code) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "GridHistoricoCaptura",
          params: { id: id, codigo: code, tipeView: "consulta" },
        });
      }, 1000);
    },
    save() {
      this.loading = true;
      this.$v.$touch();
      let idContrato = this.$store.getters.contratoStored;
      let estado = "";

      if (this.usertype == "AGENCIA") {
        estado = this.estadoGestionValue;
      } else if (this.usertype == "PROVEEDOR") {
        estado = 2;
      }

      this.body = {
        idContrato: idContrato,
        idProductosReporte: this.id,
        estado: estado,
        filename: this.filenameValue,
        documento: this.base64Value,
        observaciones: this.observaciones,
        idRelation: this.idReporte,
      };
      axios
        .post("/productoReporte/create", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.loading = false;
          this.back(this.id, this.code);
        })
        .catch((error) => {
          if (error == undefined || error == null) {
            console.log(error.response.data.defaultMessage);
          } else if (error.response.status == 400) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          } else if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION_BACK");
          }
          this.loading = false;
        });
    },

    async loadEstados() {
      this.estadosData = await this.loadEstadosData();
      let est = [];
      this.estadosData.forEach(function (e) {
        est.push({
          nombre: e.descripcion,
          code: e.code,
        });
      });
      this.estadoGestionSelect = est;
    },

    async loadEstadosData() {
      let idContrato = this.$store.getters.contratoStored;
      return await axios
        .get("/productoReporte/estadosAgencia/" + idContrato)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    formatoFecha(f) {
      return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
    },
    formatoFechaView(f) {
      return f.replace(/^(\d{2})-(\d{2})-(\d{4})$/g, "$3-$2-$1");
    },
  },
};
</script>
